var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ProjectActions } from 'app/stores/project/actions';
import { analytics } from 'app/utils/analytics';
import { prepareOnWriteToClipboard } from 'app/utils/clipboard';
export const shortcut = createAsyncThunk('keyboard/shortcut', (opts, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    const { command } = opts;
    switch (command) {
        case 'copy-to-buffer':
            analytics({
                action: 'CopyItem',
                label: 'copyToBuffer',
            });
            dispatch(ProjectActions.copy());
            break;
        case 'paste-from-buffer':
            analytics({
                action: 'pasteItem',
                label: 'pasteFromBuffer',
            });
            dispatch(ProjectActions.paste());
            break;
        case 'copy-to-clipboard':
            analytics({
                action: 'ExportAction',
                label: 'copyToClipboard',
            });
            dispatch(ProjectActions.rasterizeProject({
                format: 'image/png',
                strategy: 'current_page',
            }))
                .unwrap()
                .then(blob => prepareOnWriteToClipboard(blob, dispatch));
            break;
        default:
            break;
    }
}));
